<template>
    <a-modal
        centered
        :visible="visible"
        :title="mode == 'create' ? '新增客户标签' : '修改客户标签'"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :after-close="after_close"
        :width="680"
    >
        <a-form-model :model="form" :rules="rules" ref="_form">
            <a-form-model-item label="名称" prop="name">
                <a-input v-model="form.name"></a-input>
            </a-form-model-item>

            <!-- <a-form-model-item label="颜色" prop="color">
 
                <Swatches v-model="color" label="选择颜色" />
            </a-form-model-item> -->

            <a-form-model-item label="备注">
                <a-textarea v-model="form.remark" :auto-size="{ minRows: 1, maxRows: 6 }"></a-textarea>
            </a-form-model-item>

            <a-form-model-item label="启用条件自动检索（创建后将不能修改）" v-if="mode === 'create'">
                <a-switch v-model="form.is_term"></a-switch>
            </a-form-model-item>

            <template v-if="form.is_term">
                <a-divider orientation="left">
                    客户属性
                </a-divider>
                <a-alert message="最终匹配出的客户同样受权限管理所控制。" type="info" show-icon style="margin-bottom:24px" />

                <a-row :gutter="24">
                    <a-col :span="12">
                        <a-form-model-item label="录入/注册时间">
                            <a-radio-group v-model="form.created_scope" button-style="solid">
                                <a-radio-button value="day">今日</a-radio-button>
                                <a-radio-button value="week">本周</a-radio-button>
                                <a-radio-button value="month">本月</a-radio-button>
                                <a-radio-button value="custom">自定义</a-radio-button>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="时间区间" v-if="form.created_scope == 'custom'">
                            <a-input-group compact>
                                <a-date-picker
                                    valueFormat="YYYY-MM-DD 00:00:00"
                                    style=" width: 125px;  "
                                    placeholder="开始日期"
                                    v-model="form.created_gte"
                                />
                                <a-input
                                    style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                                    placeholder="~"
                                    disabled
                                />
                                <a-date-picker
                                    valueFormat="YYYY-MM-DD 23:59:59"
                                    style="width: 125px; border-left: 0"
                                    placeholder="截止日期"
                                    v-model="form.created_lte"
                                />
                            </a-input-group>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-form-model-item label="客户等级（支持多选）">
                    <a-checkable-tag
                        v-for="item in level_array"
                        :key="item.value"
                        :checked="form.levels.some((v) => v == item.value)"
                        @change="(e) => on_level_change(e, item.value)"
                    >
                        <a-tooltip>
                            <template slot="title">
                                {{ item.name }}
                            </template>
                            {{ item.value }}
                        </a-tooltip>
                    </a-checkable-tag>
                </a-form-model-item>
                <a-row :gutter="24"
                    ><a-col :span="12">
                        <a-form-model-item label="客户身份">
                            <a-radio-group v-model="form.member_identity" button-style="solid">
                                <a-radio-button value="buyer">买家</a-radio-button>
                                <a-radio-button value="seller">卖家</a-radio-button>
                                <a-radio-button value="both">买家+卖家</a-radio-button>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="客户行业（支持多选）">
                            <a-select v-model="form.industry_ids" mode="multiple">
                                <a-select-option v-for="item in basic_data_industry" :key="item.id">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row :gutter="24"
                    ><a-col :span="12">
                        <a-form-model-item label="归属销售（支持多选）">
                            <a-select v-model="form.user_ids" mode="multiple">
                                <a-select-option v-for="item in basic_data_user" :key="item.id">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>

                    <a-col :span="12"
                        ><a-form-model-item label="来源渠道">
                            <a-tree-select
                                v-model="form.source_id"
                                show-search
                                allow-clear
                                :getPopupContainer="(trigger) => trigger.parentNode"
                                :tree-data="basic_data_source"
                                :replaceFields="{ children: 'children', title: 'title', key: 'key', value: 'id' }"
                            /> </a-form-model-item
                    ></a-col>
                </a-row>
                <a-row :gutter="24"
                    ><a-col :span="12">
                        <a-form-model-item label="余额区间">
                            <a-input-group compact>
                                <a-input style=" width: 125px;" placeholder="大于等于" v-model="form.balance_gte" />
                                <a-input
                                    style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                                    placeholder="~"
                                    disabled
                                />
                                <a-input style="width: 125px; border-left: 0" placeholder="小于等于" v-model="form.balance_lte" />
                            </a-input-group>
                        </a-form-model-item> </a-col
                    ><a-col :span="12"></a-col
                ></a-row>
            </template>
        </a-form-model>
    </a-modal>
</template>
<script>
    import basic_data from "../../../mixins/basic_data";
    let init_form = {
        name: null,
        is_term: false,
        remark: null,
        created_scope: null,
        created_gte: null,
        created_lte: null,
        levels: [],
        identity: null,
        industry_ids: [],
        user_ids: [],
        source_id: null,
        balance_gte: null,
        balance_lte: null,
    };
    export default {
        mixins: [basic_data],
        props: {
            visible: {
                default: false,
            },
            record: null,
            mode: {
                default: "create",
            },
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        data() {
            return {
                submitting: false,
                form: null,
                color: "#111111",
                rules: {
                    name: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请输入名称",
                        },
                    ],
                },
            };
        },
        watch: {
            visible(v) {
                if (v && this.record) {
                    this.form.name = this.record.name;
                    this.form.remark = this.record.remark;
                    this.form.is_term = !!this.record.is_term;

                    //参数
                    if (this.form.is_term) {
                        Object.keys(this.form).map((v) => {
                            if (Object.prototype.hasOwnProperty.call(this.record.param, v)) {
                                this.form[v] = this.record.param[v];
                            }
                        });
                    }
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.form.color = this.color.hex;

                this.$refs["_form"].validate((valid) => {
                    if (valid) {
                        if (this.mode === "create") {
                            return this.on_store();
                        } else {
                            return this.on_update();
                        }
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            on_store() {
                this.submitting = true;
                this.$http
                    .post("/setting/member_tag", this.form)
                    .then((res) => {
                        if (res.success) {
                            this.cancel();
                            this.$emit("load");
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            on_update() {
                this.submitting = true;
                this.$http
                    .put("/setting/member_tag/" + this.record.id, this.form)
                    .then((res) => {
                        if (res.success) {
                            this.cancel();
                            this.$emit("load");
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            on_level_change(a, b) {
                if (a) {
                    this.form.levels = [...this.form.levels, b];
                } else {
                    this.form.levels.splice(
                        this.form.levels.findIndex((v) => v == b),
                        1
                    );
                }
            },
            after_close() {
                this.$refs["_form"].resetFields();
                this.form = JSON.parse(JSON.stringify(init_form));
            },
        },
    };
</script>
